module.exports = __webpack_public_path__ + "images/prey_rgba(0,0,0,0.7).jpg?v=3d560ce958789a9f7c750613f8a693b1";